<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    @click:outside="cancel"
    class="overflow-hidden"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" color="accent">
        Send Reminder
      </v-btn>
    </template>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col cols="auto" class="px-6">
            <v-img :src="$images.PULSE_SEND_REMINDER"></v-img>
          </v-col>
          <v-col>
            <div class="text-right">
              <v-btn icon @click="cancel">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div class="pb-4 text-h5 accent--text font-weight-bold">
              Authorize reminder
            </div>
            <div class="pb-4 subtitle-1 font-weight-medium">
              CoreCounts will send a reminder email to the
              {{ employeeCount }} individuals who have not completed the survey.
            </div>
            <v-btn
              :color="sent ? 'secondary' : 'accent'"
              @click="sent ? null : sendReminder()"
              :loading="saving"
            >
              {{ sent ? "Reminder sent!" : "Yes, send reminder" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SendReminderDialog",
  components: {},
  props: { pulseId: { type: String }, employeeCount: { type: Number } },
  data: () => ({
    dialog: false,
    sent: false,
    saving: false
  }),
  watch: {
    dialog(val, oldVal) {
      if (val != oldVal && !val) {
        this.sent = false;
      }
    }
  },
  created() {
    this.sent = false;
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    sendReminder() {
      this.saving = true;
      this.$store
        .dispatch("pulse/sendReminder", this.pulseId)
        .then(() => {
          this.sent = true;
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while resending a culture tracking survey."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
